import { MetricsState } from './types';

const getters = {
  getAllMetrics(state: MetricsState) {
    return state;
  }
};
export default getters;
